import { render, staticRenderFns } from "./consents-edit-modal.vue?vue&type=template&id=520ccf42&scoped=true&"
import script from "./consents-edit-modal.vue?vue&type=script&lang=ts&"
export * from "./consents-edit-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ccf42",
  null
  
)

export default component.exports